var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRecognitionSent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 79,
    viewBox: "0 0 64 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6305 48.5581C18.3077 48.2358 17.7873 48.2358 17.4668 48.5581L6.89171 59.1945C6.57125 59.5191 6.57125 60.0425 6.89171 60.3648C7.21444 60.6871 7.73488 60.6871 8.05534 60.3648L18.6305 49.7285C18.9509 49.4062 18.9509 48.8805 18.6305 48.5581Z",
    fill: "#C96E44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1087 56.5347L14.8224 61.8516C14.5019 62.1762 14.5019 62.6997 14.8224 63.022C15.1451 63.3443 15.6655 63.3443 15.986 63.022L21.2723 57.7051C21.5928 57.3805 21.5928 56.857 21.2723 56.5347C20.9519 56.2124 20.4292 56.2124 20.1087 56.5347Z",
    fill: "#C96E44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6981 45.8999C10.3754 45.5776 9.85496 45.5776 9.5345 45.8999L4.24815 51.2169C3.9277 51.5415 3.9277 52.0649 4.24815 52.3872C4.57088 52.7095 5.09132 52.7095 5.41179 52.3872L10.6981 47.0703C11.0209 46.748 11.0209 46.2223 10.6981 45.8999Z",
    fill: "#C96E44"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M58.8934 7.00346L37.7728 14.5723C37.3455 14.7254 37.1205 15.1986 37.2728 15.6306C37.4251 16.0604 37.8955 16.2867 38.3251 16.1335L56.0024 9.79947L29.6391 36.3154C28.4573 35.7051 11.2508 26.8179 10.1302 26.2391L35.2234 17.2465C35.6507 17.0934 35.8757 16.6202 35.7234 16.1882C35.5711 15.7584 35.1007 15.5321 34.6711 15.6853L7.78473 25.3204C7.47564 25.4301 7.26201 25.7158 7.23928 26.045C7.21655 26.3742 7.39155 26.6851 7.68473 26.836L21.7368 34.0934L19.5868 46.6387C19.4914 47.1987 19.9754 47.6925 20.5391 47.5964L33.0121 45.434L40.2278 59.5674C40.3687 59.844 40.6528 60.0177 40.9596 60.0177C41.3096 60.0177 41.6187 59.796 41.7346 59.4669L45.2891 49.4338C45.4414 49.0041 45.2187 48.5286 44.7891 48.3755C44.3619 48.2223 43.8891 48.4463 43.7369 48.8784L40.821 57.1072C40.2414 55.9734 31.4071 38.6715 30.8026 37.4854L57.166 10.9694L44.8431 45.7581C44.6522 46.2999 45.0522 46.8645 45.618 46.8645C45.9567 46.8645 46.2726 46.6542 46.393 46.3136L59.943 8.06171C60.1794 7.39424 59.5366 6.77489 58.8934 7.00346ZM32.2205 43.8884L21.4068 45.765L23.2727 34.8888L29.1863 37.9427L32.2205 43.8884Z",
    fill: "#C96E44"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M44 50.5L46.5 43.5",
    stroke: "#C96E44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5 17L40 14.5",
    stroke: "#C96E44",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecognitionSent);
export default __webpack_public_path__ + "static/media/recognition-sent.0648bb7ccd6a1b455acd71e2d692bca4.svg";
export { ForwardRef as ReactComponent };